import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite, resolveAssetUrl } from "../context/SiteContext";
import { CMSSections } from "../components/CMSBlockRenderer";
import { useLanguage } from "../context/LanguageContext";
import { applySeo } from "../lib/seo";

const DynamicCmsPage = () => {
  const { pathname } = useLocation();
  const { pages, loading, settings } = useSite();
  const { lang } = useLanguage();
  const page = (pages || []).find((p) => p.route === pathname && !p.built_in && p.enabled);

  useEffect(() => {
    if (loading) return;

    if (!page) {
      applySeo({
        title: lang === "ar" ? "الصفحة غير موجودة | TowerLink" : "Page Not Found | TowerLink",
        description: "",
        pathname,
        lang,
        robots: "noindex,nofollow",
      });
      return;
    }

    const seo = page.published_seo || {};
    const globalSeo = settings?.seo || {};
    const title = seo?.[`title_${lang}`] || page?.[`label_${lang}`] || globalSeo?.[`default_title_${lang}`] || "TowerLink Platform";
    const desc = seo?.[`description_${lang}`] || globalSeo?.[`default_description_${lang}`] || "";
    const image = resolveAssetUrl(seo.og_image_url || globalSeo.og_image_url || "");

    applySeo({
      title,
      description: desc,
      pathname,
      lang,
      image,
      robots: "index,follow",
    });
  }, [page, settings, lang, pathname, loading]);

  if (loading) return <div className="min-h-screen bg-[#070D1B]" />;
  if (!page) return <div className="min-h-[70vh] pt-40 text-center px-6"><h1 className="font-heading text-4xl font-bold">404</h1><p className="text-slate-400 mt-3">Page not found</p></div>;
  return <CMSSections sections={page.published_sections || []} />;
};
export default DynamicCmsPage;
